import {WithNextSlot} from "@components/Booking/useNextAvailable";
import {Location} from "@components/Booking/LocationSelection/types";
import React from "react";
import LinkOrButton from "@components/LinkOrButton";
import {Contents} from "@components/Booking/LocationSelection/LocationRow/Contents";
import {WithDistance} from "@components/Booking/LocationSelection/useWithDistanceFromUser";
import {
  borderStyles,
  containerSpaceStyles,
} from "@components/Booking/LocationSelection/LocationRow/styles";

const LocationRow = ({
  href,
  location,
  slotsLoading,
}: {
  href?: string;
  location?: WithDistance<WithNextSlot<Location>>;
  slotsLoading: boolean;
}) => {
  const styles = `${containerSpaceStyles} group`;
  if (href) {
    const activeBorderStyles = `${borderStyles} location-row sm:hover:border-t-transparent`;
    const activeStyles = `${styles} cursor-pointer sm:hover:bg-gray-100`;
    return (
      <div className={activeBorderStyles}>
        <LinkOrButton href={href} className={activeStyles}>
          <Contents disabled={false} location={location} slotsLoading={slotsLoading} />
        </LinkOrButton>
      </div>
    );
  }

  return (
    <div className={borderStyles}>
      <div className={styles}>
        <Contents disabled={true} location={location} slotsLoading={slotsLoading} />
      </div>
    </div>
  );
};

export default React.memo(LocationRow);
